import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-chat-button',
  templateUrl: './new-chat-button.component.html',
  styleUrls: ['./new-chat-button.component.scss']
})
export class NewChatButtonComponent implements OnInit {

  constructor() { }
  ngOnInit(): void {
  }

}
